import { axiosGet, axiosPost } from "../../react_axios/Axios"
import { getFeedbackVenueDetailsUrl, insertFeedbackUrl, INSERT_FEEDBACK_ACTION_TYPE, GET_FEEDBACK_VENUE_DETAILS_ACTION_TYPE, getFeedbackDetailsUrl, GET_FEEDBACK_DETAILS_ACTION_TYPE, headers, } from "../../utils/constants"
import moment from 'moment';

export const get_feedback_venue_details_action = (OrderUUID) => async (dispatch) => {
    try {
        const mapdata = {
            OrderUUID: OrderUUID,
        }
        const res = await axiosGet(getFeedbackVenueDetailsUrl, mapdata);

        dispatch({
            type: GET_FEEDBACK_VENUE_DETAILS_ACTION_TYPE,
            payload: res,
        });
        // console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const insert_feedback_action = (OrderUUID, Communication, Services, VenueFeaturesQuality, VenueFeaturesInternet, VenueFeaturesWashroom, VenueFeaturesAmbiance, VenueFeaturesOverall, VendorServiceCatering, VendorServiceAudio, VendorServiceRental, VendorServiceSecurity, VendorServiceFloral, VendorServiceHousekeeping, VendorServiceHost, feedbackComment) => async (dispatch) => {
    try {
        const mapdata = {
            OrderUUID: OrderUUID,
            Communication: Communication,
            Services: Services,
            VenueFeaturesQuality: VenueFeaturesQuality,
            VenueFeaturesInternet: VenueFeaturesInternet,
            VenueFeaturesWashroom: VenueFeaturesWashroom,
            VenueFeaturesAmbiance: VenueFeaturesAmbiance,
            VenueFeaturesOverall: VenueFeaturesOverall,
            VendorServiceCatering: VendorServiceCatering,
            VendorServiceAudio: VendorServiceAudio,
            VendorServiceRental: VendorServiceRental,
            VendorServiceSecurity: VendorServiceSecurity,
            VendorServiceFloral: VendorServiceFloral,
            VendorServiceHousekeeping: VendorServiceHousekeeping,
            VendorServiceHost: VendorServiceHost,
            feedbackComment: feedbackComment
        }
        const res = await axiosPost(insertFeedbackUrl, mapdata, headers);

        dispatch({
            type: INSERT_FEEDBACK_ACTION_TYPE,
            payload: res,
        });
        // console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const get_feedback_details_action = (OrderID) => async (dispatch) => {
    try {
        const mapdata = {
            OrderID: OrderID,
        }
        const res = await axiosGet(getFeedbackDetailsUrl, mapdata);

        dispatch({
            type: GET_FEEDBACK_DETAILS_ACTION_TYPE,
            payload: res,
        });
        // console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};
